import { TNodeProps } from '../types/node';
import { BaseNode } from './BaseNode';
import { StandardHandles } from './StandardHandles';

export const LLMNode = (props: TNodeProps) => {
  return (
    <BaseNode {...props}>
      <StandardHandles withReverseVerticals />
    </BaseNode>
  );
};
